import React from "react";
import styles from "./Capibilities.module.css";
import first from "../images/First.svg";
import second from "../images/Second.svg";
import third from "../images/Third.svg";

const Capabilities = () => {
  return (
    <section className={styles.capabilities}>
      <div className="container">
        <div className="row">
        <div className={`col-lg-12 col-md-12 col-12 ${styles.mainDiv} text-center `}>
          <h2 className={styles.head}>Our capabilities</h2>
          <p className={styles.para}>
            Functionalities to facilitate an <br />
            improved <span className={styles.highlight}>experience</span>
          </p>
        </div>
        </div>
        <div className={` row  ${styles.cardDiv}`}>
          <div className={`col-lg-4  ${styles.border}`}>
            <div className={styles.card}>
              <img src={first} className={styles.image} />
              <h3 className={styles.cardHeading}>Share Team Inboxes</h3>
              <p className={styles.cardInfo}>
                Whether you have a team of 2 or 200, our shared team inboxes
                keep everyone on the same page and in the loop.
              </p>
            </div>
          </div>
          <div className={`col-lg-4 ${styles.border} `}>
            <div className={styles.card}>
              <img src={second} className={styles.image} />
              <h3 className={styles.cardHeading}>Deliver Instant Answers</h3>
              <p className={styles.cardInfo}>
                An all-in-one customer service platform that helps you balance
                everything your customers need to be happy.
              </p>
            </div>
          </div>
          <div className={`col-lg-4  `}>
            <div className={styles.card}>
              <img src={third} className={styles.image} />
              <h3 className={styles.cardHeading}>Manage Team Reports</h3>
              <p className={styles.cardInfo}>
                Measure what matters with Untitled’s easy-to-use reports. You
                can filter, export, and drilldown on the data in a couple
                clicks.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Capabilities;
